import Swiper from 'swiper';
import { Grid, Pagination } from 'swiper/modules';

let promotionSwipers = new Map(); // Store multiple swiper instances

function initOrDestroySwiper() {
  const containers = document.querySelectorAll('.promotions-slider .swiper');
  const isMobile = window.innerWidth <= 767;

  containers.forEach(container => {
    const containerId = container.id || container.closest('.promotions-slider').id || `promotions-slider-${Array.from(containers).indexOf(container)}`;
    
    if (isMobile && !promotionSwipers.has(containerId)) {
      if (!container.querySelector('.swiper-pagination')) {
        const pag = document.createElement('div');
        pag.className = 'swiper-pagination';
        container.appendChild(pag);
      }

      const swiper = new Swiper(container, {
        modules: [Grid, Pagination],
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        centeredSlides: false,
        normalizeSlideIndex: true,
        roundLengths: true,
        watchSlidesProgress: true,
        grid: {
          rows: 1,
          fill: 'row',
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
        },
        breakpoints: {
          // Small phones
          320: {
            slidesPerView: 1,
            spaceBetween: 12,
          },
          // Medium phones
          480: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          // Large phones / small tablets
          640: {
            slidesPerView: 1,
            spaceBetween: 16,
          }
        },
        on: {
          init: function() {
            // Force recalculation on init
            setTimeout(() => {
              this.updateSize();
              this.updateSlides();
              this.updateProgress();
              this.updateSlidesClasses();
            }, 100);
          },
          slideChange: function() {
            // Force recalculation of slide positions
            this.updateSlides();
            this.updateProgress();
          },
          resize: function() {
            // Force recalculation on resize
            this.updateSize();
            this.updateSlides();
          }
        }
      });
      
      // Force update after creation
      setTimeout(() => {
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
      }, 150);
      
      promotionSwipers.set(containerId, swiper);
    }
    else if (!isMobile && promotionSwipers.has(containerId)) {
      const swiper = promotionSwipers.get(containerId);
      swiper.destroy(true, true);
      promotionSwipers.delete(containerId);
      const pag = container.querySelector('.swiper-pagination');
      if (pag) pag.remove();
    }
  });
}

// on load
window.addEventListener('DOMContentLoaded', initOrDestroySwiper);
// on resize (debounced)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initOrDestroySwiper, 200);
});

// Run immediately if DOM is already loaded to prevent flicker
if (document.readyState === 'loading') {
  // DOM hasn't finished loading yet
  window.addEventListener('DOMContentLoaded', initOrDestroySwiper);
} else {
  // DOM has already loaded
  initOrDestroySwiper();
}